import React from "react";
import PropTypes from "prop-types";
import FuxCursorPaginator from "../../../components/BaseComponents/FuxCursorPaginator/FuxCursorPaginator";
import {FaSolidIcon} from "../../../components/FontAwesomeIcons";
import {UsersModuleEventsAPI} from "../../../api/UsersModuleEvents/UsersModuleEventsAPI";
import {UserEventReservationItem} from "./UserEventReservationItem";

export class UserEventReservationsList extends React.Component {
    constructor(props) {
        super(props);
        this.classItemsContainer = "list-group";
        this.addReservationIconStyle = {
            width: "34px",
            minWidth: "34px",
            height: "34px",
        };
    }

    handlePageRequest = cursor => UsersModuleEventsAPI.Admin.Reservations.reservationPagination(this.props.eventId, cursor)

    handleItemRender = reservation => (
        <UserEventReservationItem
            reservation={reservation}
            onClick={this.props.onReservationClick}
        />
    )

    handleEmptyPage = _ => (
        <div className={"text-center text-muted py-4 card card-body shadow-sm border-0"}>
            Non ci sono ancora adesioni.
        </div>
    )

    render() {
        return (
            <div>
                <h6 className={"font-weight-bold mb-2"}>Adesioni ricevute</h6>

                <button
                    type={"button"}
                    className={"btn btn-light border shadow-sm btn-block text-left p-3 mb-3 d-flex align-items-center"}
                    onClick={this.props.onCreateReservationClick}
                >
                    <span
                        className={"rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mr-3"}
                        style={this.addReservationIconStyle}
                    >
                        <FaSolidIcon name={"plus"}/>
                    </span>
                    <span>
                        <span className={"font-weight-bold d-block"}>Aggiungi adesione</span>
                        <span className={"small text-muted"}>Inserimento manuale per conto di un invitato</span>
                    </span>
                </button>

                <FuxCursorPaginator
                    classItemsContainer={this.classItemsContainer}
                    onItemRender={this.handleItemRender}
                    onPageRequest={this.handlePageRequest}
                    onEmptyPage={this.handleEmptyPage}
                />
            </div>
        );
    }
}

UserEventReservationsList.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onReservationClick: PropTypes.func,
    onCreateReservationClick: PropTypes.func,
};
